import React, { Component } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import get from 'lodash/get';
import { Select, MenuItem, InputLabel, FormControl, FormHelperText } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';

const styles = (theme) => ({
    disabled: {},
    focused: {},
    formControl: {
        width: '100%',
    },
    menuItem: {
        display: 'flex',
        flexDirection: 'column',
        height: 'auto',
        alignItems: 'baseline',
    },
    optionDescription: {
        fontSize: theme.typography.pxToRem(10),
    },
    icon: {},
    selectRoot: {},
});

/**
 * FormSelect
 * - comon component for inputs within console app
 * @param {{ form: object, label: string, placeholder: string }} props
 */
// eslint-disable-next-line react/prefer-stateless-function
class FormSelect extends Component {
    // eslint-disable-next-line react/static-property-placement
    static defaultProps = {
        optionList: [],
    };

    render() {
        const {
            form,
            intl,
            formItemKey,
            initialValue,
            label,
            placeholder,
            emptyListMessage = '',
            additionalRules = [],
            classes = {},
            isRequired = false,
            optionList,
            optionListIsLoading = false,
            labelPath,
            onChange,
            validateTrigger = 'onChange',
            preserve = true,
            fullWidth
        } = this.props;

        const { getFieldDecorator } = form;
        const errors = form.getFieldError(formItemKey);
        return (
            <>
                <FormControl id="yeself-select-form-wrapper" className={classes.selectRoot} fullWidth={fullWidth}>
                    {label && (
                        <InputLabel shrink htmlFor={formItemKey}>
                            {label}
                        </InputLabel>
                    )}
                    {getFieldDecorator(formItemKey, {
                        initialValue,
                        validateTrigger,
                        preserve,
                        rules: [
                            {
                                required: isRequired,
                                message: intl.formatMessage({ id: 'Form.field.isRequired' }),
                            },
                            ...(additionalRules && additionalRules.length > 0 ? additionalRules : []),
                        ],
                    })(
                        <Select
                            id="yeself-select-form"
                            autoWidth
                            disabled={optionListIsLoading || optionList.length === 0}
                            onChange={onChange}
                            renderValue={(value) => value.name}
                            classes={{ root: classes.selectRoot, icon: classes.icon }}
                        >
                            {optionList.map((option, index) => (
                                <MenuItem
                                    id="yeself-menu-item"
                                    key={option.id || index}
                                    value={option}
                                    className={classes.menuItem}
                                >
                                    {labelPath ? get(option, labelPath) : option.name}
                                    <span className={classes.optionDescription}>
                                        {option.description}
                                    </span>
                                </MenuItem>
                            ))}
                        </Select>
                    )}
                    {errors && errors.length > 0 && <FormHelperText>{placeholder}</FormHelperText>}
                    {!errors && optionList.length === 0 && <FormHelperText>{emptyListMessage}</FormHelperText>}
                </FormControl>
            </>
        );
    }
}

export default withStyles(styles)(injectIntl(FormSelect));
